import { object, string } from 'yup';

export const mileagePlusVerificationSchema = () =>
  object({
    membershipId: string().required('The field is required'),
    surname: string().required('The field is required'),
  });
